import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import UpdateIcon from "@material-ui/icons/Update";
import { useMutation, useApolloClient } from "@apollo/react-hooks";
import { Loading } from ".";
import alertify from "alertifyjs";
import _ from "lodash";

const defaultToolbarSelectStyles = {
  iconButton: {
    marginRight: "24px",
    top: "50%",
    display: "inline-block",
    position: "relative",
  },
};

function CustomToolbarSelectWithUpdate(prop) {
  const client = useApolloClient();
  alertify.defaults.transition = "zoom";
  alertify.defaults.theme.ok = "ui positive button";
  alertify.defaults.theme.cancel = "ui black button";
  const list = prop.selectedRows.data.map((listItem) => {
    const x = listItem.index;
    if (prop.displayData[x]) return prop.displayData[x]["data"][0];
  });
  //console.log("list:", list);
  const eachDeleteItems = (cachedata) => {
    let rows = [];
    for (let i of cachedata) {
      let control = true;
      for (let ii of list) {
        if (i.id === ii) control = false;
      }
      if (control) rows.push(i);
    }
    return rows;
  };

  const deleteMethod = prop.deleteMethod;
  const [deleteItems, { loading }] = useMutation(prop.mutation, {
    variables: {
      data: {
        id: list,
        company: JSON.parse(localStorage.getItem("currentcompany")).id,
      },
    },
    onCompleted(data) {
      const deletedCount = data[deleteMethod].deletedCount;
      if (prop.selectedRows.data.length === deletedCount) {
        alertify.success(
          deletedCount + " Adet Kayıt Başarı ile Silinmiştir.",
          3
        );
      } else {
        alertify.error(
          "Silinen Kayıt ile Gönderilen Kayıt Sayısında Hata var.",
          3
        );
      }
    },
    async update(cache, { data }) {
      const queryData = [prop.queryData];
      const cachedata = cache.readQuery({
        ...prop.query,
      });

      const rows = await eachDeleteItems(cachedata[queryData]);
      //console.log("rows:", rows);
      cache.writeQuery({
        ...prop.query,
        data: {
          [queryData]: rows,
        },
      });
      prop.changeInitialState(rows);
      prop.setSelectedRows([]);
    },
    onError(err) {
      const x = err.message.split(":", 3);
      alertify.error(x[2], 3);
    },
  });

  const handleObjectToValue = (data) => {
    const keys = Object.keys(data);
    let Data = {};
    for (let i of keys) {
      if (data[i]) {
        Data[i] = data[i].id ? data[i].id : data[i];
      }
    }
    //console.log("Data:", Data);
    return { ...Data };
  };

  if (loading) return <Loading />;

  return (
    <span>
      {!prop.noUpdate && (
        <Tooltip title={"Seçili Kaydı Güncelle"}>
          <IconButton
            style={defaultToolbarSelectStyles.iconButton}
            onClick={() => {
              if (list.length == 1) {
                const updateData = list[0];
                const queryData = [prop.queryData];
                const cachedata = client.readQuery({
                  ...prop.query,
                });
                prop.changeState({
                  page: "update",
                  addUpdate: {
                    data: handleObjectToValue(
                      _.find(cachedata[queryData], { id: updateData })
                    ),
                  },
                });
              } else
                alertify.error(
                  " Güncelleme yapmak için en fazla bir kayıt seçebilirsiniz!!!",
                  3
                );
            }}
          >
            <UpdateIcon />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title={"Seçili Kayıtları Sil"}>
        <IconButton
          style={defaultToolbarSelectStyles.iconButton}
          onClick={() => {
            alertify.confirm(
              "!",
              prop.selectedRows.data.length +
                " Adet Kaydı Silmek Üzeresiniz. Devam Etmek İstiyormusunuz?",
              function () {
                deleteItems();
              },
              function () {
                alertify.error("Silme İşlemi İptal Edildi.", 2);
              }
            );
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </span>
  );
}

export default CustomToolbarSelectWithUpdate;
